import { dataHooks } from '../../../../libs/dataHooks';

export const forYouTemplatesGridDataHooks = dataHooks<{
  template;
}>('forYouTemplatesGrid');
